export default "__VITE_ASSET__mxx_FSGI__"